import React from 'react';

import { Heading, Primitive, Text } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

type TitleProps = {
  titleKey?: string;
  subTitleKey?: string;
  titleArgs?: Record<string, unknown>;
};

export const Title: React.FC<TitleProps> = ({
  titleKey,
  titleArgs = {},
  subTitleKey,
}) => {
  const { t } = useTranslation();

  return (
    <Primitive.div display="flex" alignItems="center">
      {titleKey && <Heading level="3">{t(titleKey, titleArgs)}</Heading>}

      {subTitleKey && <Text marginLeft="smedium">{t(subTitleKey)}</Text>}
    </Primitive.div>
  );
};
